define( function() {
	"use strict";

	return Object.getPrototypeOf;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/getProto.js
// module id = 704
// module chunks = 0